
import WebFont from 'webfontloader'

const options = {"google":{"families":["Cabin+Sketch:700&display=swap"],"urls":["https:\u002F\u002Ffonts.googleapis.com\u002Fearlyaccess\u002Fthabit.css"]}}

WebFont.load(options)
